export const GET_NEWS_REQUEST = 'app/services/News/GET_NEWS_REQUEST';
export const GET_NEWS_SUCCESS = 'app/services/News/GET_NEWS_SUCCESS';
export const GET_NEWS_FAILURE = 'app/services/News/GET_NEWS_FAILURE';
export const POST_NEWS_REQUEST = 'app/services/News/POST_NEWS_REQUEST';
export const POST_NEWS_SUCCESS = 'app/services/News/POST_NEWS_SUCCESS';
export const POST_NEWS_FAILURE = 'app/services/News/POST_NEWS_FAILURE';
export const DELETE_NEWS_REQUEST = 'app/services/News/DELETE_NEWS_REQUEST';
export const DELETE_NEWS_SUCCESS = 'app/services/News/DELETE_NEWS_SUCCESS';
export const DELETE_NEWS_FAILURE = 'app/services/News/DELETE_NEWS_FAILURE';
export const PUT_NEWS_REQUEST = 'app/services/News/PUT_NEWS_REQUEST';
export const PUT_NEWS_SUCCESS = 'app/services/News/PUT_NEWS_SUCCESS';
export const PUT_NEWS_FAILURE = 'app/services/News/PUT_NEWS_FAILURE';

export const actionGetNewsRequest = () => ({
    type: GET_NEWS_REQUEST,
});

export const actionGetNewsSuccess = (data) => ({
    type: GET_NEWS_SUCCESS,
    payload: data,
});

export const actionGetNewsFailure = (error) => ({
    type: GET_NEWS_FAILURE,
    error,
});

export const actionDeleteNewsRequest = () => ({
    type: DELETE_NEWS_REQUEST,
});

export const actionDeleteNewsSuccess = (data) => ({
    type: DELETE_NEWS_SUCCESS,
    payload: data,
});

export const actionDeleteNewsFailure = (error) => ({
    type: DELETE_NEWS_FAILURE,
    error,
});

export const actionPutNewsRequest = () => ({
    type: DELETE_NEWS_REQUEST,
});

export const actionPutNewsSuccess = (data) => ({
    type: DELETE_NEWS_SUCCESS,
    payload: data,
});

export const actionPutNewsFailure = (error) => ({
    type: DELETE_NEWS_FAILURE,
    error,
});

export const actionPostNewsRequest = () => ({
    type: POST_NEWS_REQUEST,
});

export const actionPostNewsSuccess = (data) => ({
    type: POST_NEWS_SUCCESS,
    payload: data,
});

export const actionPostNewsFailure = (error) => ({
    type: POST_NEWS_FAILURE,
    error,
});
